var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11903_1260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 4.66659V3.46659C11.9999 2.71985 11.9999 2.34648 11.8546 2.06126C11.7268 1.81038 11.5228 1.60641 11.2719 1.47858C10.9867 1.33325 10.6133 1.33325 9.86659 1.33325H6.13325C5.38652 1.33325 5.01315 1.33325 4.72793 1.47858C4.47705 1.60641 4.27307 1.81038 4.14524 2.06126C3.99992 2.34648 3.99992 2.71985 3.99992 3.46659V4.66659M3.99992 11.9999C3.37994 11.9999 3.06995 11.9999 2.81561 11.9318C2.12543 11.7468 1.58633 11.2077 1.4014 10.5176C1.33325 10.2632 1.33325 9.95323 1.33325 9.33325V7.86659C1.33325 6.74648 1.33325 6.18643 1.55124 5.7586C1.74299 5.38228 2.04895 5.07632 2.42527 4.88457C2.85309 4.66659 3.41315 4.66659 4.53325 4.66659H11.4666C12.5867 4.66659 13.1467 4.66659 13.5746 4.88457C13.9509 5.07632 14.2569 5.38228 14.4486 5.7586C14.6666 6.18643 14.6666 6.74648 14.6666 7.86659V9.33325C14.6666 9.95323 14.6666 10.2632 14.5984 10.5176C14.4135 11.2077 13.8744 11.7468 13.1842 11.9318C12.9299 11.9999 12.6199 11.9999 11.9999 11.9999M9.99992 6.99992H11.9999M6.13325 14.6666H9.86659C10.6133 14.6666 10.9867 14.6666 11.2719 14.5213C11.5228 14.3934 11.7268 14.1895 11.8546 13.9386C11.9999 13.6534 11.9999 13.28 11.9999 12.5333V11.4666C11.9999 10.7198 11.9999 10.3465 11.8546 10.0613C11.7268 9.81038 11.5228 9.60641 11.2719 9.47858C10.9867 9.33325 10.6133 9.33325 9.86659 9.33325H6.13325C5.38652 9.33325 5.01315 9.33325 4.72793 9.47858C4.47705 9.60641 4.27307 9.81038 4.14524 10.0613C3.99992 10.3465 3.99992 10.7198 3.99992 11.4666V12.5333C3.99992 13.28 3.99992 13.6534 4.14524 13.9386C4.27307 14.1895 4.47705 14.3934 4.72793 14.5213C5.01315 14.6666 5.38652 14.6666 6.13325 14.6666Z",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11903_1260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter);
export default __webpack_public_path__ + "static/media/printer.7a091ca9083829a2dc03224bc08fa0d7.svg";
export { ForwardRef as ReactComponent };